import { render, staticRenderFns } from "./FullImage.vue?vue&type=template&id=1d6c81c8&scoped=true&lang=pug&"
import script from "./FullImage.vue?vue&type=script&lang=js&"
export * from "./FullImage.vue?vue&type=script&lang=js&"
import style0 from "./FullImage.vue?vue&type=style&index=0&id=1d6c81c8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6c81c8",
  null
  
)

export default component.exports